import {FC, useState, useEffect} from 'react'
import {Avatar, Divider, Flex, Layout, Menu, Typography} from 'antd'
import {userSelector} from '../../../store/global'
import {useAppSelector} from '../../../store/hooks'
import {useLocation, useNavigate} from 'react-router-dom'
import {FaGraduationCap, FaSearch} from 'react-icons/fa';
import {
    AppstoreOutlined,
    BarChartOutlined,
    BookOutlined, CheckOutlined, FontSizeOutlined,
    HomeOutlined,
    QuestionCircleOutlined, ReadOutlined,
    TableOutlined, TeamOutlined
} from "@ant-design/icons";
import {Link} from 'react-router-dom';
import {TbCards} from "react-icons/tb";
import {NavigationPages} from "../../../common/navigation/navigation-pages";
import Constants from "../../../const/Constants";
import UserUtil from "../../utils/UserUtil";
import {FaBlog} from "react-icons/fa6";
import IconTelegram from "../../elements/svg_icons/IconTelegram";
import IconVK from "../../elements/svg_icons/IconVK";
import './navigation-bar.scss'


const {Sider} = Layout;
const {Text} = Typography;

function useIsMobile(breakpoint = 480) {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth < breakpoint)

    useEffect(() => {
        const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)
        const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches)
        setIsMobile(mq.matches)
        mq.addEventListener('change', handler)
        return () => mq.removeEventListener('change', handler)
    }, [breakpoint])

    return isMobile
}

interface NavigationBarProps {
    visible: boolean
    resetVisibility: () => {}
}

const BOTTOM_BAR_HEIGHT = 70;

const NavigationBar: FC<NavigationBarProps> = ({visible, resetVisibility}) => {
    const navigate = useNavigate()
    const user = useAppSelector(userSelector)
    const location = useLocation().pathname

    const menuItems = [
        {
            key: NavigationPages.GARDEN,
            icon: <HomeOutlined/>,
            label: <Link to={NavigationPages.GARDEN}>Мой сад</Link>,
        },
        {
            key: NavigationPages.DICTIONARY,
            icon: <BookOutlined/>,
            label: <Link to="/dictionary">Словарь</Link>,
        },
        {
            key: '/execises',
            icon: <AppstoreOutlined/>,
            label: <span>Упражнения</span>,
            children: [
                {
                    key: NavigationPages.CARDS,
                    icon: <TbCards/>,
                    label: <Link to={NavigationPages.CARDS}>Карточки</Link>,
                }, {
                    key: NavigationPages.TEST,
                    icon: <QuestionCircleOutlined/>,
                    label: <Link to={NavigationPages.TEST}>Тесты</Link>,
                },
                {
                    key: NavigationPages.GUESS_WORD,
                    icon: <FontSizeOutlined/>,
                    label: <Link to={NavigationPages.GUESS_WORD}>Заполни пропуски</Link>,
                },
                {
                    key: NavigationPages.FILL_WORDS,
                    icon: <TableOutlined/>,
                    label: <Link to={NavigationPages.FILL_WORDS}>Филворды</Link>,
                },
            ],
        },
        {
            key: NavigationPages.DONE_WORDS_LISTS,
            icon: <CheckOutlined/>,
            label: <Link to={NavigationPages.DONE_WORDS_LISTS}>Готовые списки</Link>,
        },
        {
            key: NavigationPages.COMMUNITIES,
            icon: <TeamOutlined/>,
            label: <Link to={NavigationPages.COMMUNITIES}>Сообщества</Link>,
        },
        {
            key: NavigationPages.COURSES_LIST,
            icon: <FaGraduationCap/>,
            label: <Link to={NavigationPages.COURSES_LIST}>Курсы</Link>,
        },
        {
            key: NavigationPages.BOOKS,
            icon: <ReadOutlined/>,
            label: <Link to={NavigationPages.BOOKS}>Книги</Link>,
        },
        {
            key: NavigationPages.MYSTERY_QUEST,
            icon: <FaSearch/>,
            label: <Link to={NavigationPages.MYSTERY_QUEST}>Квест (alpha)</Link>,
        },
        {
            key: NavigationPages.STATISTIC,
            icon: <BarChartOutlined/>,
            label: <Link to={NavigationPages.STATISTIC}>Статистика</Link>,
        },
        {
            key: NavigationPages.BLOG,
            icon: <FaBlog/>,
            label: <Link to='https://blog.voxlingua.com/' target="_blank">Блог</Link>,
        }

    ];
    const userImg = UserUtil.getPhotoUrl(user)

    const isMobile = useIsMobile(480)

    const goToProfile = () => {
        resetVisibility()
        navigate(`/profile/${user.id}`)

    }

    return (
        <Sider
            className="nav-sider"
            width={!isMobile ? 260 : '100vw'}
            style={{
                display: !isMobile || visible ? 'block' : 'none',
                paddingBottom: isMobile ? BOTTOM_BAR_HEIGHT : 0,
            }}
        >
            <Flex vertical justify="space-between" style={{height: '100%'}}>
                <div>
                    <Flex align="center" gap="small" className="nav-sider__logo">
                        <img src="../images/custom/logo.png" alt="Logo" style={{height: 32}}/>
                        <Text strong style={{fontSize: 18}}>VoxLingua</Text>
                    </Flex>
                    <Divider className="nav-sider__divider"/>
                    <Menu
                        onClick={() => resetVisibility()}
                        mode="inline"
                        selectedKeys={[location]}
                        items={menuItems}
                        className="nav-sider__menu"
                    />
                </div>
                <div>
                    <Divider className="nav-sider__divider"/>
                    <Flex
                        align="center"
                        gap="small"
                        className="nav-sider__profile"
                        onClick={goToProfile}
                    >
                        <Avatar size="large" src={userImg}/>
                        <Typography.Text strong>Профиль</Typography.Text>
                    </Flex>
                    <Flex gap={8} className="nav-sider__socials">
                        <a href="https://t.me/geekenglishru" target="_blank" rel="noopener noreferrer">
                            <IconTelegram stroke="var(--color-text-muted)" width={20} height={20}/>
                        </a>
                        <a href="https://vk.ru/voxlingua" target="_blank" rel="noopener noreferrer">
                            <IconVK stroke="var(--color-text-muted)" width={20} height={20}/>
                        </a>
                    </Flex>
                </div>
            </Flex>
        </Sider>
    )
}

export default NavigationBar
